import InspirationPane from './InspirationPane';

export default InspirationPane;
export { InspirationPane };
